import React from 'react'

export default function Special() {
    return (
        <div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div class="section-header">
                <p><span>Special Offer</span></p>
            </div>
            <img src={require('../assets/img/dis.jpg')} class="imgspecial" id="specialimg" alt="logo" />
            <br />
            <br />
            <h1><span>Hotels</span></h1>
            <div class="row gy-4">

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/hotel 1.avif')} class="imghotel1" id="hotel1img" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Residence Inn Hotel</h5>
                            <h6>Enjoy special rooms at the hollywood-themed hotel featuring restaurent and a piano-themed outdoor pool and Disney's California Adventure theme parks.</h6>
                            <br />
                            <button><a href="https://disneyworld.disney.go.com/resorts/more/residence-inn/" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <h5><span>Sale 40%</span>off</h5>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/hotel2.webp')} class="imghotel1" id="hotel1img" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Anaheim Hotel</h5>
                            <h6>The Home2 Suites by Hilton Anaheim Resort, CA is conveniently located across from the entrance to Disneyland. </h6>
                            <br />
                            <button><a href="https://www.agoda.com/en-in/super-8-by-wyndham-anaheim-disneyland-drive/hotel/los-angeles-ca-us.html?finalPriceView=1&isShowMobileAppPrice=false&cid=1914936&numberOfBedrooms=&familyMode=false&adults=1&children=0&rooms=1&maxRooms=0&checkIn=2023-07-17&isCalendarCallout=false&childAges=&numberOfGuest=0&missingChildAges=false&travellerType=-1&showReviewSubmissionEntry=false&currencyCode=INR&isFreeOccSearch=false&tag=49ea4ea7-2b56-4daa-a936-ade668b5b7fb&isCityHaveAsq=false&tspTypes=8,8&los=1&searchrequestid=f3e8a3de-c060-4730-914d-5fc46a6b2d8a" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <h5><span>Sale 40%</span>off</h5>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/paris1.webp')} class="imghotel1" id="hotel1img" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Conrad orlando  Hotel</h5>
                            <h6>Inside the lush 1,100 acres at Evermore Orlando Resort is a captivating retreat. Buffered by a nature preserve, Conrad Orlando offers everything.</h6>
                            <br />
                            <button><a href="https://www.hilton.com/en/hotels/orlcici-conrad-orlando/" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <h5><span>Sale 40%</span>off</h5>
                        </div>
                        <br />
                    </div>
                </div>
                <br />
                <h1>Games</h1>
                <div class="row gy-4">

                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                        <div class="chef-member">
                            <div class="member-img">
                                <img src={require('../assets/img/t.webp')} class="imghotel2" id="hotel2img" alt="logo" />
                                <div class="social">
                                    <a href=""><i class="bi bi-twitter"></i></a>
                                    <a href=""><i class="bi bi-facebook"></i></a>
                                    <a href=""><i class="bi bi-instagram"></i></a>
                                    <a href=""><i class="bi bi-linkedin"></i></a>
                                </div>
                            </div>
                            <div class="member-info">
                                <h4>Roller Coster</h4>
                                <span>Wonderful</span>
                                <p>ncredicoaster is both quite long (more than 6,000 feet and a 2 minute, 36-second ride time) and arguably the biggest thrill at the entire resort, being its only inverted coaster, a 55 miles-per-hour launch and a 108-foot drop.</p>
                            </div>
                            <button><a href="https://www.tripsavvy.com/must-ride-roller-coasters-in-the-united-states-4685000" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <a href="https://youtu.be/n3K9vGWuIOo" class="glightbox btn-watch-video align-items-center"><i class="bi bi-play-circle"></i><span>Watch Video</span></a>

                            <br />
                            <br />
                            <h5><span>Sale 60%</span>off</h5><br />
                            <br />
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                        <div class="chef-member">
                            <div class="member-img">
                                <img src={require('../assets/img/saorin.jpg')} class="imghotel2" id="hotel2img" alt="logo" />
                                <div class="social">
                                    <a href=""><i class="bi bi-twitter"></i></a>
                                    <a href=""><i class="bi bi-facebook"></i></a>
                                    <a href=""><i class="bi bi-instagram"></i></a>
                                    <a href=""><i class="bi bi-linkedin"></i></a>
                                </div>
                            </div>
                            <div class="member-info">
                                <h4>Saorin</h4>
                                <span>Dengerous but Wonderfull</span>
                                <p>Soarin' Around the World is in the Grizzly Peak Airfield section of Disney California Adventure at the Disneyland Resort One of the resort's most popular attractions, it utilizes the park's FastPass system.</p>
                            </div>
                            <br />
                            <button><a href="https://www.attractiontickets.com/en/paris-attraction-tickets/disneyland-paris-tickets/1-day-2-parks-disneyland-paris-hopper-ticket" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <a href="https://youtu.be/Zh4V0vfN5QE" class="glightbox btn-watch-video align-items-center"><i class="bi bi-play-circle"></i><span>Watch Video</span></a>
                            
                            <br/>
                            <br/>
                            <h5><span>Sale 60%</span>off</h5><br />
                            <br />
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="300">
                        <div class="chef-member">
                            <div class="member-img">
                                <img src={require('../assets/img/fun.webp')} class="imghotel2" id="hotel2img" alt="logo" />
                                <div class="social">
                                    <a href=""><i class="bi bi-twitter"></i></a>
                                    <a href=""><i class="bi bi-facebook"></i></a>
                                    <a href=""><i class="bi bi-instagram"></i></a>
                                    <a href=""><i class="bi bi-linkedin"></i></a>
                                </div>
                            </div>
                            <div class="member-info">
                                <h4>Fun Park</h4>
                                <span>Funny Park</span>
                                <p>Disneyland is a theme park in Anaheim, California. Opened in 1955, it was the first theme park opened by The Walt Disney Company and the only one designed and constructed under the direct supervision of Walt Disney. </p>
                            </div>
                            <button><a href="https://www.getyourguide.com/paris-l16/disneyland-paris-full-day-entrance-ticket-t10734/" className='rounded-pill m-5'>Book Now</a></button>
                            <br />
                            <br />
                            <a href="https://youtu.be/2Cb7s2U93pg" class="glightbox btn-watch-video align-items-center"><i class="bi bi-play-circle"></i><span>Watch Video</span></a>
                            <br/>
                            <br/>
                            <h5><span>Sale 60%</span>off</h5>
                            <br />
                            <br />
                        </div>
                    </div>

                </div>



            </div>
        </div>

    )
}
